module.exports = __webpack_public_path__ + "img/instagramestory6-1.8297b8a0.jpg";